import { aboutContent, appContent, contactContent } from '@/mocks/homeData';

export function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center md:text-left">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">{aboutContent.title}</h2>
          {aboutContent.paragraphs.map((para, i) => (
            <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {para}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0">
            <img
              src={appContent.previewImage}
              alt="黑料入口APP截图"
              className="w-[260px] md:w-[300px] h-auto rounded-2xl"
              width="300"
              height="450"
              loading="lazy"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{appContent.title}</h2>
            <p className="text-sm text-foreground-500 mb-6">{appContent.tagline}</p>
            <div className="grid grid-cols-2 gap-3 mb-8 max-w-md mx-auto lg:mx-0">
              {appContent.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500"></i>
                  <span>{feat}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-4">
              <div className="w-28 h-28 bg-background-50 rounded-xl p-2">
                <img src={appContent.qrCodeImage} alt="扫码下载" className="w-full h-full object-contain" loading="lazy" />
              </div>
              <span className="text-xs text-foreground-400">扫一扫<br/>下载APP</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{contactContent.title}</h2>
          <p className="text-sm text-foreground-500 mb-10">{contactContent.intro}</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {contactContent.items.map((item) => (
              <div key={item.label} className="p-6 bg-background-100 rounded-xl text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-full mx-auto mb-3">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.label}</h3>
                <p className="text-sm text-foreground-600 break-all">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}